<template>
  <div>
    <h3 class="text-white text-lg font-semibold mb-4">AutoVolt.ai</h3>
    <p class="text-sm">
      {{ tx.frase }}
    </p>
    <div class="mt-4">
      <a
        href="https://instagram.com/autovolt.ai"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center text-gray-400 hover:text-white transition-colors"
      >
        <Instagram class="h-5 w-5 mr-2" />
        @autovolt.ai
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Instagram } from 'lucide-vue-next'
import { useTextos } from '../../i18n/idioma'

const tx = useTextos({
  pt: { frase: 'Transformando negócios com Inteligência Artificial e Automações' },
  en: { frase: 'Transforming businesses with Artificial Intelligence and Automation' },
  es: { frase: 'Transformando negocios con Inteligencia Artificial y Automatizaciones' },
})
</script>